/**
 * Module voor het ontvangen van berichten van de node.js server
 * retourneerd een geintialiseerde Faye client
 */
define('utils/socket.io',['jquery', 'lib/socket.io', 'utils/common'], function($, io) {
	//Geeft aan of server gebruiker mag volgen
	var visible = !(new RegExp("(?:^|;\\s*)hidden\\s*\\=")).test(document.cookie);
	
	//URL relatief aan base
	var socket = io.connect(document.location.origin, {
		resource: $('meta[name=base]').attr('content').substring(document.location.origin.length+1) + 'socket.io',
		transports: [
			'websocket',
			//'flashsocket',
			'htmlfile',
			'xhr-polling',
			'jsonp-polling',
		]
	});
	
	socket.on('message', function(data) {
		$.message(message.text);
	});
	
	socket.on('online', function(data) {
		//Verander online icoontjes
		$('.online-' + data.id).each(function() {
			$(this).toggleClass('icon-online', data.online);
			$(this).toggleClass('icon-offline', !data.online);
		});
	});
	
	var setVisible = function(toggle) {
		if (toggle) {
			if (visible)
				document.cookie = "hidden=true";
			else
				document.cookie = "hidden=; expires=Thu, 01 Jan 1970 00:00:00 GMT";

			visible = !visible;
			
			socket.emit('visible', visible);
		}
        else
        {
            socket.emit('visible', visible);
        }

		var status = $('#visible-icon');
		status.toggleClass('icon-offline', !visible);
		status.toggleClass('icon-online', visible);
	};
	setVisible(false);

	$('#visible').click(function(e) {
		e.preventDefault();
		$('#profileBox').removeClass('show');
		setVisible(true);
	});
	
	return io;
});
